import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isEditLaborHours: false,
  loading: false,
};

export const editLaborHoursReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.EDIT_LABOR_HOURS_SUCCESS: {
      return {
        ...state,
        isEditLaborHours: true,
        response: action.payload,
        loading: false,
      };
    }

    case laborHoursConstant.EDIT_LABOR_HOURS_FAILURE:
      return {
        ...state,
        isEditLaborHours: false,
        response: action.payload,
        loading: false,
      };

    case laborHoursConstant.EDIT_LABOR_HOURS_LOADER:
      return {
        ...state,
        loading: true,
      };

    case laborHoursConstant.EDIT_LABOR_HOURS_RESET:
      return intitialstate;

    default:
      return state;
  }
};
